module.exports = __webpack_public_path__ + "223387aabe5e14a6b744b14bf8fd0878.svg";